import React, { FC, useEffect, useState } from 'react';

import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from '@chakra-ui/react';

type DeletePurchaseOrderDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  poNumber?: string;
  isDeleting: boolean;
  onConfirm: (reasonForDeletion: string) => void;
};

const DeletePurchaseOrderDialog: FC<DeletePurchaseOrderDialogProps> = ({
  isOpen,
  onClose,
  poNumber,
  isDeleting,
  onConfirm,
}) => {
  const [reasonForDeletion, setReasonForDeletion] = useState('');

  useEffect(() => {
    if (isOpen) {
      setReasonForDeletion('');
    }
  }, [isOpen]);

  const canDelete = reasonForDeletion.trim().length > 0 && !isDeleting;

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius="10px">
        <ModalCloseButton
          isDisabled={isDeleting}
          _focus={{ outline: 'none' }}
        />
        <ModalHeader mt={4}>Delete Purchase Order</ModalHeader>
        <ModalBody>
          <Text mb={4}>
            Are you sure you want to delete
            {poNumber ? ` purchase order ${poNumber}` : ' this purchase order'}?
            This action is permanent and cannot be undone.
          </Text>
          <FormControl isRequired>
            <FormLabel fontSize="12px" color="#afafaf">
              Reason for deletion
            </FormLabel>
            <Textarea
              value={reasonForDeletion}
              minH="120px"
              placeholder="Enter a reason for deleting this purchase order"
              isDisabled={isDeleting}
              onChange={(event) => setReasonForDeletion(event.target.value)}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="outline"
            mr={3}
            isDisabled={isDeleting}
            onClick={onClose}>
            Cancel
          </Button>
          <Button
            bg="#E53E3E"
            isLoading={isDeleting}
            isDisabled={!canDelete}
            onClick={() => onConfirm(reasonForDeletion.trim())}>
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeletePurchaseOrderDialog;
